export function clamp(value: number, min = 0, max = Infinity) {
  return Math.min(max, Math.max(min, value))
}

export function clampIndex(value: number, length: number) {
  return clamp(value, 0, length - 1)
}
